export const COMMIT_HASH = 'efc7d063da54ba5a74267bb3217a56ae4db602e2';
